import { useEffect, useRef, useState } from 'react';
import { motion, useInView } from 'framer-motion';

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-80px' });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    const duration = 1600;
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(eased * value));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  return (
    <span ref={ref} className="font-display text-4xl sm:text-5xl font-[700] text-white tracking-tight">
      {n.toLocaleString()}{suffix}
    </span>
  );
};

const Stats = ({ t }) => {
  return (
    <section id="stats" className="relative py-20 sm:py-24 bg-[rgb(var(--bg-1))]" data-testid="stats-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="kicker-mono mb-3">{t.stats.kicker}</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-[650] tracking-tight text-white">{t.stats.title}</h2>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {t.stats.items.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.08 }}
              className="rounded-2xl border border-white/10 bg-[rgb(var(--bg-2))] p-6 hover:border-[rgba(5,126,243,.5)] transition-colors"
              data-testid={`stat-${i}`}
            >
              <Counter value={s.value} suffix={s.suffix} />
              <div className="mt-2 kicker-mono text-white/60">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
